const FlywireModalTokenization = ({
    firstName,
    lastName,
    email,
    phone,
    address,
    city,
    zip,
    country,
    successCallback,
    locale = "en"
}) => {
    let config = {
        env: process.env.REACT_APP_FLYWIRE_ENV,
        recipientCode: process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,

        // >0 for Seed Payment and Optional Tokenization; 0 for Zero-Value Tokenization;
        amount: 0,
        //Mandatory tokenization before payment - "tokenization" or "optional_tokenization";
        recurringType: "tokenization",
        recurringTypeRecipientCodes: [
            process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,
            process.env.REACT_APP_FLYWIRE_JPT_RECIPIENT_CODE,
        ],

        // Other checkout parameters (e.g. pass payer info or set requestPayerInfo to true)
        firstName: firstName,
        lastName: lastName,
        email: email,
        phone: phone,
        address: address,
        city: city,
        zip: zip,
        country: country,

        locale: locale,

        // Control which tokenization options are available
        paymentOptionsConfig: {
            filters: {
                type: ["credit_card", "direct_debit"],
            },
        },
        onCompleteCallback: function (args) {
            successCallback(args);
        },
    };

    let modal = window.FlywirePayment.initiate(config);
    modal.render();
}

export default FlywireModalTokenization;